import { render, staticRenderFns } from "./tenantManagement.vue?vue&type=template&id=b15086de&scoped=true&"
import script from "./tenantManagement.vue?vue&type=script&lang=js&"
export * from "./tenantManagement.vue?vue&type=script&lang=js&"
import style0 from "./tenantManagement.vue?vue&type=style&index=0&id=b15086de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15086de",
  null
  
)

export default component.exports